import {
  axiosInstance as axios,
  axiosInstance,
} from "../../redux/constants/axiosInstance";

import {
  //Maintencne
  API_URL,
  FETCH_MAINTENANCE_LIST,
  ADD_MAINTENANCE,
  FETCH_MAINTENANCE_TYPE,
  FETCH_MAINTENANCE_STATUS_LIST,
  DELETE_MAINTENANCE,
  ASSIGN_MANINTENANCE,
  CHANGE_MAINTENANCE_STATUS,
  FETCH_ASSET_CLIENT_LIST,
  DELETE_ASSET_CHECKLIST,
  MARK_CHECKLIST_COMPLETE,
  ADD_ASSET_CHECKLIST,
  UPDATE_MAINTENANCE,
  FETCH_MAINTENANCE_BY_ID,
  ADD_COMMENT,
  DELETE_PO,
  FETCH_WORK_ORDERS,
  ADD_WORK_ORDERS,
  UPDATE_WORK_ORDER,
  FETCH_NEXT_WORKID,
} from "../constants/type";

export const getMaintenanceList = (id) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/Asset/GetMaintainanceList`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      assetId: id,
      pageNumber: 1,
      perPageRequired: 10,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_MAINTENANCE_LIST,
      data: response.data.data._data,
    });

    return Promise.resolve([]);
  });
};
export const addNewMaintenance = (data) => (dispatch) => {
  let details = data;
  delete data.from;
  axios({
    method: "post",
    url: `${API_URL}/api/Asset/AddNewMaintainace`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      ...data,
    },
  }).then((response) => {
    // dispatch({
    //   type: ADD_MAINTENANCE,
    //   data: { ...details, ...response.data.data },
    // });
    if (data.form) {
      // dispatch({
      //   type: ADD_WORK_ORDERS,
      //   data: { ...data, ...response.data.data },
      // });
    }

    return Promise.resolve([]);
  });
};

export const duplicateMaintenance = (data) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/Asset/DuplicateMaintenance`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      ...data,
    },
  }).then((response) => {
    // dispatch({
    //   type: ADD_WORK_ORDERS,
    //   data: { ...data, ...response.data.data },
    // });

    return Promise.resolve([]);
  });
};

export const maintainaceStatusList = () => (dispatch) => {
  axios({
    method: "get",
    url: `${API_URL}/api/Asset/MaintainaceStatusList`,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    dispatch({
      type: FETCH_MAINTENANCE_STATUS_LIST,
      data: response.data.data,
    });

    return Promise.resolve([]);
  });
};

export const MaintainaceTypeList = () => (dispatch) => {
  axios({
    method: "get",
    url: `${API_URL}/api/Asset/MaintainaceTypeList`,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    dispatch({
      type: FETCH_MAINTENANCE_TYPE,
      data: response.data.data,
    });

    return Promise.resolve([]);
  });
};

export const deleteMaintenance = (assetMaintainaceId) => (dispatch) => {
  axios({
    method: "delete",
    url: `${API_URL}/api/Asset/DeleteMaintainace/${assetMaintainaceId}`,
    headers: {
      "Content-Type": "application/json",
    },
    data: { assetMaintainaceId },
  }).then((response) => {
    dispatch({
      type: DELETE_MAINTENANCE,
      data: { assetMaintainaceId },
    });
    return Promise.resolve([]);
  });
};

export const changeMaintenanceStatus =
  (assetMaintainaceId, statusId) => (dispatch) => {
    axios({
      method: "put",
      url: `${API_URL}/api/Asset/ChangeMaintainaceStatus`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { assetMaintainaceId, statusId },
    }).then((response) => {
      dispatch({
        type: CHANGE_MAINTENANCE_STATUS,
        data: { assetMaintainaceId, statusId },
      });
      return Promise.resolve([]);
    });
  };

export const updateMaintenance = (data) => (dispatch) => {
  axios({
    method: "put",
    url: `${API_URL}/api/Asset/UpdateMaintainace`,
    headers: {
      "Content-Type": "application/json",
    },
    data: { ...data },
  }).then((response) => {
    dispatch({
      type: UPDATE_MAINTENANCE,
      data: { ...response.data.data, ...data },
    });
    if (data.from) {
      dispatch({
        type: UPDATE_WORK_ORDER,
        data: { ...response.data.data, ...data },
      });
    }
    dispatch(getMaintenanceList(data.associatedAssetId));
    return Promise.resolve([]);
  });
};
export const assignMaintenence =
  (assetMaintainaceId, assignTo) => (dispatch) => {
    axios({
      method: "put",
      url: `${API_URL}/api/Asset/MaintainaceAssignTo`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { assetMaintainaceId, assignTo: assignTo.userId },
    }).then((response) => {
      dispatch({
        type: ASSIGN_MANINTENANCE,
        data: { assetMaintainaceId, assignTo },
      });
      return Promise.resolve([]);
    });
  };

export const fetchMaintenance = (assetMaintainanceId) => (dispatch) => {
  axios({
    method: "get",
    url: `${API_URL}/api/Asset/GetMaintainaceById/${assetMaintainanceId}`,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    dispatch({
      type: FETCH_MAINTENANCE_BY_ID,
      data: response.data.data,
    });

    return Promise.resolve([]);
  });
};

export const fetchClientList = () => (dispatch) => {
  axios({
    method: "get",
    url: `${API_URL}/api/Asset/ClientList`,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    dispatch({
      type: FETCH_ASSET_CLIENT_LIST,
      data: response.data.data,
    });

    return Promise.resolve([]);
  });
};

export const deleteCheckList = (checkListId) => (dispatch) => {
  axios({
    method: "delete",
    url: `${API_URL}/api/Asset/DeleteChecklistTask/${checkListId}`,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    dispatch({
      type: DELETE_ASSET_CHECKLIST,
      data: { checkListId },
    });
    return Promise.resolve([]);
  });
};

export const markCheckListComplete = (checkListId) => (dispatch) => {
  axios({
    method: "delete",
    url: `${API_URL}/api/Asset/MarkChecklistTaskComplete/${checkListId}`,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    dispatch({
      type: MARK_CHECKLIST_COMPLETE,
      data: { checkListId },
    });
    return Promise.resolve([]);
  });
};

export const deletePO = (poId) => (dispatch) => {
  axios({
    method: "delete",
    url: `${API_URL}/api/Asset/DeleteMaintainacePurchaseorder/${poId}`,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    dispatch({
      type: DELETE_PO,
      data: { poId },
    });
    return Promise.resolve([]);
  });
};

export const addAssetcomment = (data) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/Asset/AddComment`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      ...data,
    },
  }).then((response) => {
    dispatch({
      type: ADD_COMMENT,
      data: { ...data, ...response.data.data },
    });

    return Promise.resolve([]);
  });
};

export const fetchWorkOrders =
  (companyId, sortby, querystring, perPage, currentPage) => (dispatch) => {
    axios({
      method: "post",
      url: `${API_URL}/api/Asset/FetchWorkOrders`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        companyId,
        sortby: sortby,
        querystring: querystring,
        pagerequire: perPage,
        pagenumber: currentPage,
      },
    }).then((response) => {
      dispatch({
        type: FETCH_WORK_ORDERS,
        data: response.data,
      });

      return Promise.resolve([]);
    });
  };

export const GetNextWorkId = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/api/Asset/NextMaintainaceWorkId`,
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const AddNewMaintenanceType = async (data) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/Asset/AddNewMaintenanceType`,
      data,
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const NextMaintainaceWorkId = () => async (dispatch) => {
  try {
    const response = await axios({
      method: "get",
      url: `${API_URL}/api/Asset/NextMaintainaceWorkId`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: FETCH_NEXT_WORKID,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
